import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Megaphone,
  Library,
  UploadCloud,
  Users2,
  Layers3,
  TrendingUp,
  Wand2,
  FileBarChart2,
  Settings as Cog,
  ShieldCheck,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { TID } from "@/constants/testIds";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, tid: TID.navDashboard, end: true },
  { to: "/campaigns", label: "Campaigns", icon: Megaphone, tid: TID.navCampaigns },
  { to: "/curve-library", label: "Curve Library", icon: Library, tid: TID.navCurveLibrary },
  { to: "/upload-curve", label: "Upload Curve Files", icon: UploadCloud, tid: TID.navUploadCurve },
  { to: "/vendors", label: "Vendor Parameters", icon: Users2, tid: TID.navVendors },
  { to: "/ddf", label: "De-Duplication", icon: Layers3, tid: TID.navDDF },
  { to: "/budget-sensitivity", label: "Budget Sensitivity", icon: TrendingUp, tid: TID.navBudgetSensitivity },
  { to: "/optimizer", label: "Optimizer", icon: Wand2, tid: TID.navOptimizer },
  { to: "/reports", label: "Reports", icon: FileBarChart2, tid: TID.navReports },
  { to: "/users", label: "User Management", icon: ShieldCheck, tid: "nav-users", adminOnly: true },
  { to: "/settings", label: "Settings", icon: Cog, tid: TID.navSettings },
];

export default function Sidebar() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  return (
    <aside
      data-testid={TID.sidebar}
      className="hidden md:flex w-[260px] shrink-0 flex-col border-r border-slate-200 bg-white"
    >
      <div className="h-16 flex items-center gap-3 px-5 border-b border-slate-200">
        <img
          src="/logo-harmony.png"
          alt="HARMONY"
          data-testid={TID.sidebarLogo}
          className="h-9 w-9 object-contain"
        />
        <div>
          <div className="font-display font-bold text-[#0A3D91] text-lg leading-none tracking-tight">
            HARMONY
          </div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-0.5">
            Media Optimization
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {NAV.filter((item) => !item.adminOnly || isAdmin).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={item.tid}
            className={({ isActive }) => `side-link ${isActive ? "active" : ""}`}
          >
            <item.icon className="side-icon h-4 w-4 text-slate-500" strokeWidth={2} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-4 py-4 border-t border-slate-200">
        <div className="rounded-lg p-3 bg-gradient-to-br from-[#0A3D91] to-[#1CC7B3] text-white">
          <div className="text-xs font-medium opacity-90">Pro Tip</div>
          <div className="text-sm mt-1 leading-snug">
            Upload TV + OLV curves together to unlock combined reach optimization.
          </div>
        </div>
      </div>
    </aside>
  );
}
